import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=9607ac36&scoped=true"
import script from "./Interview.vue?vue&type=script&setup=true&lang=js"
export * from "./Interview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Interview.vue?vue&type=style&index=0&id=9607ac36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607ac36",
  null
  
)

export default component.exports